/**
 * @generated SignedSource<<3fee14a78969bdde35da48f33213778e>>
 * @relayHash 2353edfd5e69ad073019c4bb8349a109
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a2ec984ea33495adcbba94336e1a3f16de40867829b547192a16447daa97ad61

import type { ConcreteRequest, Query } from 'relay-runtime';
export type HelpCenterSortOrder = "CREATED_DATE_ASCENDING" | "CREATED_DATE_DESCENDING" | "%future added value";
export type helpCenterFetchWithProjectMappingQuery$variables = {
  SORT_ORDER: HelpCenterSortOrder;
  after?: string | null | undefined;
  cloudId: string;
  first: number;
  projectId: string;
  workspaceAri: string;
};
export type helpCenterFetchWithProjectMappingQuery$data = {
  readonly helpCenter: {
    readonly helpCentersByProjectId: {
      readonly __typename: "HelpCenterQueryResultConnection";
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id?: string;
          readonly name?: {
            readonly default: string;
          } | null | undefined;
          readonly slug?: string | null | undefined;
        } | null | undefined;
      }> | null | undefined;
      readonly nodes: ReadonlyArray<{
        readonly __typename: "QueryError";
        readonly extensions: ReadonlyArray<{
          readonly errorType: string | null | undefined;
          readonly statusCode: number | null | undefined;
        }> | null | undefined;
        readonly identifier: string | null | undefined;
        readonly message: string | null | undefined;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      }> | null | undefined;
      readonly pageInfo: {
        readonly endCursor: string | null | undefined;
        readonly hasNextPage: boolean;
      };
    } | null | undefined;
  } | null | undefined;
};
export type helpCenterFetchWithProjectMappingQuery = {
  response: helpCenterFetchWithProjectMappingQuery$data;
  variables: helpCenterFetchWithProjectMappingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "SORT_ORDER"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceAri"
},
v6 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v7 = {
  "kind": "Variable",
  "name": "projectId",
  "variableName": "projectId"
},
v8 = {
  "kind": "Variable",
  "name": "sortOrder",
  "variableName": "SORT_ORDER"
},
v9 = {
  "kind": "Variable",
  "name": "workspaceAri",
  "variableName": "workspaceAri"
},
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    (v11/*: any*/),
    {
      "concreteType": "HelpCenterName",
      "kind": "LinkedField",
      "name": "name",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "default"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "slug"
    }
  ],
  "type": "HelpCenter"
},
v13 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v14 = {
  "kind": "ScalarField",
  "name": "message"
},
v15 = {
  "kind": "ScalarField",
  "name": "identifier"
},
v16 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v17 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v18 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v19 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/)
],
v20 = {
  "kind": "InlineFragment",
  "selections": [
    (v11/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "helpCenterFetchWithProjectMappingQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "alias": "helpCentersByProjectId",
            "args": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "concreteType": "HelpCenterQueryResultConnection",
            "kind": "LinkedField",
            "name": "__multiHcDropdownContentFragment_helpCentersByProjectId_connection",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "concreteType": "HelpCenterQueryResultEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v10/*: any*/)
                    ]
                  },
                  (v13/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v14/*: any*/),
                      (v15/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": true,
                        "selections": [
                          (v16/*: any*/),
                          (v17/*: any*/)
                        ]
                      }
                    ],
                    "type": "QueryError"
                  }
                ]
              },
              (v18/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "helpCenterFetchWithProjectMappingQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v19/*: any*/),
            "concreteType": "HelpCenterQueryResultConnection",
            "kind": "LinkedField",
            "name": "helpCentersByProjectId",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "concreteType": "HelpCenterQueryResultEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v12/*: any*/),
                      (v20/*: any*/)
                    ]
                  },
                  (v13/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v14/*: any*/),
                      (v15/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": true,
                        "selections": [
                          (v10/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/)
                        ]
                      }
                    ],
                    "type": "QueryError"
                  },
                  (v20/*: any*/)
                ]
              },
              (v18/*: any*/)
            ]
          },
          {
            "args": (v19/*: any*/),
            "filters": [
              "projectId",
              "workspaceAri",
              "sortOrder"
            ],
            "handle": "connection",
            "key": "multiHcDropdownContentFragment_helpCentersByProjectId",
            "kind": "LinkedHandle",
            "name": "helpCentersByProjectId"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a2ec984ea33495adcbba94336e1a3f16de40867829b547192a16447daa97ad61",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "helpCenter",
            "helpCentersByProjectId"
          ]
        }
      ]
    },
    "name": "helpCenterFetchWithProjectMappingQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "807c8c0ebad75d6e8369741625a7c116";

export default node;
